import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons';

import styles from './TravelstoryHeader.module.scss';
import Props from './TravelstoryHeader.props';

const TravelstoryHeader = ({ title, description, backgroundImage, imageAuthor }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.TravelstoryHeader}>
      {!!backgroundImage && (
        <Image
          src={backgroundImage}
          alt=""
          quality={60}
          layout="fill"
          className={styles.BackgroundImage}
          data-testid="backgroundImage"
          priority
        />
      )}
      {imageAuthor && <div className={styles.Copyright}>{`©${imageAuthor}`}</div>}
      <div className={styles.Content}>
        <div className={styles.IconWrapper}>
          <Image
            src={require('@assets/images/icons/icon-reisverhaal-white.svg')}
            alt=""
            quality={60}
            className={styles.Icon}
            layout="fill"
          />
        </div>
        <h1 className={styles.Title} data-testid="title">
          {title}
        </h1>
        <p className={styles.Description} data-testid="description">
          {description}
        </p>
        <div className={styles.ReadMore}>
          <FontAwesomeIcon icon={faChevronCircleDown} className={styles.ReadMoreIcon} />
          <p className={styles.ReadMoreText}>{t('GENERIC.READ_MORE')}</p>
        </div>
      </div>
    </div>
  );
};

export default TravelstoryHeader;
